import axios from 'axios';
import reviewStars from './review-stars/review-stars.vue';
import reviewHelpful from './review-helpful/review-helpful.vue';
import reviewPagination from './review-pagination/review-pagination.vue';
import reviewForms from './review-forms/review-forms.vue';
import reviewDistribution from './review-distribution/review-distribution.vue';
import reviewCard from './review-card/review-card.vue';
import loadingAnimation from '../loading-animation.vue';
import { yotpoMixin } from '../mixins/yotpo-mixins.js';
import {
  Sort,
  SizePurchased,
  CustomerHeight,
  CustomerWeight,
  BodyType,
  BodyBuild,
  BodyTypeBottoms,
  ReviewFilters,
  KidsHeight,
  KidsWeight,
  YotpoTags,
} from '../enums/yotpo';

export default {
  name: 'yotpoReviews',

  components: {
    ReviewStars: reviewStars,
    ReviewHelpful: reviewHelpful,
    ReviewPagination: reviewPagination,
    ReviewForms: reviewForms,
    ReviewDistribution: reviewDistribution,
    ReviewCard: reviewCard,
    LoadingAnimation: loadingAnimation,
  },

  props: [
    'productId',
    'productTitle',
    'productUrl',
    'productType',
    'productTags',
  ],

  mixins: [yotpoMixin],

  data() {
    return {
      loading: true,
      error: false,
      reviews: [],
      bottomLine: {},
      numReviews: 0,
      showAllReviews: false,
      page: 1,
      resultsPerPage: 10,
      starDistribution: {},
      fitDescription: '',
      submitReviewForm: false,
      reviewsFiltered: true,
      searchByRatingScore: '',
      numFilteredReviews: 0,
      Sort,
      sortMethod: Sort.newest,
      searchText: '',
      pictured: '',
      reviewsWithImages: [],
      reviewsWithoutImages: [],
      filterByRating: false,
      sizePurchased: '',
      customerHeight: '',
      kidHeight: '',
      customerWeight: '',
      kidWeight: '',
      bodyType: '',
      bodyBuild: '',
      bodyTypeBottoms: '',
      SizePurchased,
      CustomerHeight,
      CustomerWeight,
      BodyType,
      BodyBuild,
      BodyTypeBottoms,
      ReviewFilters,
      KidsHeight,
      KidsWeight,
      isKidsProduct: false,
      isPack: false,
      isApparel: false,
      isBottoms: false,
      YotpoTags,
    };
  },

  computed: {
    filteredReviews() {
      let filteredReviews = Object.create(this.reviews);
      // sort ratings
      if (this.sortMethod === Sort.newest) {
        filteredReviews = filteredReviews.sort(
          (a, b) => new Date(b.readableDate) - new Date(a.readableDate)
        );
      } else if (this.sortMethod === Sort.highestRating) {
        filteredReviews = filteredReviews.sort((a, b) => b.score - a.score);
      } else if (this.sortMethod === Sort.lowestRating) {
        filteredReviews = filteredReviews.sort((a, b) => a.score - b.score);
      } else if (this.sortMethod === Sort.votesMost) {
        filteredReviews = filteredReviews.sort(
          (a, b) => b.votes_up - a.votes_up
        );
      } else if (this.sortMethod === Sort.votesLeast) {
        filteredReviews = filteredReviews.sort(
          (a, b) => b.votes_down - a.votes_down
        );
      } else if (this.sortMethod === Sort.includesImg) {
        filteredReviews = this.reviewsWithImages.concat(
          this.reviewsWithoutImages
        );
      }

      //filter by rating
      if (parseInt(this.searchByRatingScore)) {
        let reviewsFilteredByRating = filteredReviews.filter(
          (review) => review.score == parseInt(this.searchByRatingScore)
        );
        filteredReviews = reviewsFilteredByRating;
      }

      //filter by search
      if (this.searchText) {
        let reviewsFilteredBySearch = filteredReviews.filter((review) =>
          review.content.includes(this.searchText)
        );
        filteredReviews = reviewsFilteredBySearch;
      }
      //filiter by images
      if (this.pictured === true) {
        let reviewsFilteredByImages = filteredReviews.filter(
          (review) => review.images_data
        );
        filteredReviews = reviewsFilteredByImages;
      }

      //filter by size purchased
      if (this.sizePurchased) {
        let reviewsFilteredBySizePurchased = [];
        filteredReviews.forEach((review) => {
          if (review.custom_fields) {
            for (const [key, value] of Object.entries(review.custom_fields)) {
              if (
                (value.title === ReviewFilters.sizePurchased ||
                  value.title === ReviewFilters.sizeOrdered) &&
                value.value.trim() === this.sizePurchased
              ) {
                reviewsFilteredBySizePurchased.push(review);
              }
            }
          }
        });
        filteredReviews = reviewsFilteredBySizePurchased;
      }

      //filter by customer height
      if (this.customerHeight) {
        let reviewsFilteredByHeight = [];
        filteredReviews.forEach((review) => {
          if (review.custom_fields) {
            for (const [key, value] of Object.entries(review.custom_fields)) {
              //console.log(value.value + '--->');
              //console.log(this.customerHeight);
              if (
                value.title === ReviewFilters.customerHeight &&
                value.value.trim() === this.customerHeight
              ) {
                reviewsFilteredByHeight.push(review);
              }
            }
          }
        });
        filteredReviews = reviewsFilteredByHeight;
      }

      //filter by kids height
      if (this.kidHeight) {
        let reviewsFilteredByKidsHeight = [];
        filteredReviews.forEach((review) => {
          if (review.custom_fields) {
            for (const [key, value] of Object.entries(review.custom_fields)) {
              if (
                value.title === ReviewFilters.height &&
                value.value.trim() === this.kidHeight
              ) {
                reviewsFilteredByKidsHeight.push(review);
              }
            }
          }
        });
        filteredReviews = reviewsFilteredByKidsHeight;
      }

      //filter by customer weight
      if (this.customerWeight) {
        let reviewsFilteredByWeight = [];
        filteredReviews.forEach((review) => {
          if (review.custom_fields) {
            for (const [key, value] of Object.entries(review.custom_fields)) {
              if (
                value.title === ReviewFilters.customerWeight &&
                value.value.trim() === this.customerWeight
              ) {
                reviewsFilteredByWeight.push(review);
              }
            }
          }
        });
        filteredReviews = reviewsFilteredByWeight;
      }

      //filter by child's weight
      if (this.kidWeight) {
        let reviewsFilteredByKidWeight = [];
        filteredReviews.forEach((review) => {
          if (review.custom_fields) {
            for (const [key, value] of Object.entries(review.custom_fields)) {
              if (
                value.title === ReviewFilters.weight &&
                value.value.trim() === this.kidWeight
              ) {
                reviewsFilteredByKidWeight.push(review);
              }
            }
          }
        });
        filteredReviews = reviewsFilteredByKidWeight;
      }

      //filter by customer body type
      if (this.bodyType) {
        let reviewsFilteredByBodyType = [];
        filteredReviews.forEach((review) => {
          if (review.custom_fields) {
            for (const [key, value] of Object.entries(review.custom_fields)) {
              if (
                (value.title === ReviewFilters.bodyType ||
                  value.title === ReviewFilters.bodyShape ||
                  value.title === ReviewFilters.customerBodyType) &&
                value.value.trim() === this.bodyType
              ) {
                reviewsFilteredByBodyType.push(review);
              }
            }
          }
        });
        filteredReviews = reviewsFilteredByBodyType;
      }

      //filter by customer body type for bottoms
      if (this.bodyTypeBottoms) {
        let reviewsFilteredByBodyTypeBottoms = [];
        filteredReviews.forEach((review) => {
          if (review.custom_fields) {
            for (const [key, value] of Object.entries(review.custom_fields)) {
              if (
                value.title === ReviewFilters.bodyType &&
                value.value.trim().includes(this.bodyTypeBottoms)
              ) {
                reviewsFilteredByBodyTypeBottoms.push(review);
              }
            }
          }
        });
        filteredReviews = reviewsFilteredByBodyTypeBottoms;
      }

      //filter by customer body build (bags)
      if (this.bodyBuild) {
        let reviewsFilteredByBodyBuild = [];
        filteredReviews.forEach((review) => {
          if (review.custom_fields) {
            for (const [key, value] of Object.entries(review.custom_fields)) {
              if (
                value.title === ReviewFilters.bodyType &&
                value.value.trim() === this.bodyBuild
              ) {
                reviewsFilteredByBodyBuild.push(review);
              }
            }
          }
        });
        filteredReviews = reviewsFilteredByBodyBuild;
      }
      this.page = 1;
      this.numFilteredReviews = filteredReviews.length;
      this.reviewsFiltered = true;
      return filteredReviews;
    },
  },

  methods: {
    // get bottom line info (total ratings, rating distribution, etc.)
    getBottomLine() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/yotpo/bottomLine/${this.productId}`
        )
        .then((res) => {
          if (res.data.bottomline) {
            // set average score
            this.avgScore =
              Math.round(Number(res.data.bottomline.average_score * 10)) / 10;

            //set total number of reviews
            this.numReviews = Number(res.data.bottomline.total_review);

            //set star disribution
            this.starDistribution = res.data.bottomline.star_distribution;

            //set fit description
            if (res.data.bottomline.custom_fields_bottomline) {
              //Bottomline Fit data comes through with a variety of custom question keys,
              //this will go through the keys and look for a value of 'Overall Fit'
              //if it finds 'Overall Fit', it'll set the fit description to the returned value
              for (const [key, value] of Object.entries(
                res.data.bottomline.custom_fields_bottomline
              )) {
                if (value.title === 'Overall Fit' || 'Overall Size') {
                  this.setFitDescription(value.score);
                }
              }
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.error = true;
        });
    },

    // get actual reviews data
    getReviews(scroll = false) {
      this.loading = true;
      axios
        .get(
          `https://production-access-api.cotopaxi.com/yotpo/allYotpoReviewsByProductId/${this.productId}`
        )
        .then((res) => {
          // check for reviews in response
          if (res.data && res.data.length > 0) {
            this.reviews = res.data.map((review) => {
              // decode html to remove entities like '&#x27;'
              review.content = this.decodeHtml(review.content);
              review.title = this.decodeHtml(review.title);
              review.user.display_name = this.decodeHtml(
                review.user.display_name
              );

              if (review.custom_fields) {
                this.decodeFitDescription(review.custom_fields);
              }

              if (review.comment) {
                review.comment.content = this.decodeHtml(
                  review.comment.content
                );
              }

              // add human readable date
              review.readableDate = new Date(
                review.created_at
              ).toLocaleDateString();

              if (review.comment) {
                review.comment.readableDate = new Date(
                  review.comment.created_at
                ).toLocaleDateString();
              }

              // truncate description if longer than 350 char
              if (review.content.length > 350) {
                review.truncated = true;
                review.truncatedDescrip = review.content.substring(0, 351);
                review.expanded = false;
              } else {
                review.truncated = false;
                review.truncatedDescrip = review.content;
                review.expanded = true;
              }
              review.showFullReview = false;

              return review;
            });
          } else {
            this.reviews = [];
          }
          this.filterReviewsWithImgs();
          this.numFilteredReviews = res.data.length;
          this.loading = false;
          this.reviewsFiltered = false;
        })
        .catch((err) => {
          this.loading = false;
          this.error = true;
        });

      if (scroll) {
        //scroll to top of reviews section
        const el = document.getElementById('product-reviews');
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    // decode HTML to remove hex-encoded entities from Yotpo responses
    decodeHtml(html) {
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },

    // expand the description of individual review
    expandDescription(review) {
      if (review.expanded) {
        review.expanded = false;
      } else {
        review.expanded = true;
      }
    },
    // show all reviews
    loadMoreReviews() {
      this.showAllReviews = !this.showAllReviews;
    },
    // change page with pagination and get more reviews
    changePage(newPage) {
      this.page = newPage;
      const el = document.getElementById('product-reviews');
      el.scrollIntoView({ behavior: 'smooth' });
    },
    //opens review submission form
    writeReview() {
      this.submitReviewForm = true;
    },
    //closes review submission form
    closeReviewForm(value) {
      this.submitReviewForm = value;
    },
    //resets filters
    clearFilters() {
      this.searchByRatingScore = '';
      this.searchText = '';
      this.pictured = false;
      this.sizePurchased = '';
      this.customerHeight = '';
      this.customerWeight = '';
      this.bodyType = '';
      this.bodyBuild = '';
      this.bodyTypeBottoms = '';
      this.kidHeight = '';
      this.kidWeight = '';
      this.reviewsFiltered = false;
    },
    //sorts reviews by newest, then separates reviews with images out from reviews without,
    //and merges the two arrays putting any reviews with images at the top
    async filterReviewsWithImgs() {
      await this.sortByDate();
      this.reviewsWithImages = this.reviews.filter((review) => {
        return review.images_data;
      });
      this.reviewsWithoutImages = this.reviews.filter((review) => {
        return !review.images_data;
      });
    },
    //sorts reviews by newest
    sortByDate() {
      this.reviews.sort((a, b) => {
        return new Date(b.readableDate) - new Date(a.readableDate);
      });
    },

    //sets overall fit data on indivdual reviews from numeric answer to human readable answer
    decodeFitDescription(customFields) {
      if (customFields) {
        for (const [key, value] of Object.entries(customFields)) {
          if (
            value.title === 'Overall Fit' ||
            value.title === 'Fit' ||
            value.title === 'Overall Size'
          ) {
            if (value.value == 1) {
              value.value = 'Runs Small';
            } else if (value.value == 2) {
              value.value = 'True to Size';
            } else if (value.value == 3) {
              value.value = 'Fits Large';
            }
          }
        }
      }
    },
    //sets bottomline overall fit description
    setFitDescription(score) {
      if (score == 1) {
        this.fitDescription = 'Small';
      } else if (score == 3) {
        this.fitDescription = 'Large';
      } else {
        this.fitDescription = 'True to size';
      }
    },

    //determines which filters will display
    setProductTypeForReviews(productTags) {
      const packFilters = [YotpoTags.allpa, YotpoTags.packs];
      const apparelFilters = [
        YotpoTags.fugeo,
        YotpoTags.apparel,
        YotpoTags.generalInsulation,
      ];
      if (packFilters.some((tag) => productTags.includes(tag))) {
        this.isPack = true;
      } else if (productTags.includes(YotpoTags.kidsInsulation)) {
        this.isKidsProduct = true;
      } else if (apparelFilters.some((tag) => productTags.includes(tag))) {
        this.isApparel = true;
      } else if (productTags.includes(YotpoTags.bottoms)) {
        this.isBottoms = true;
      }
    },
  },

  mounted() {
    // get reviews data
    this.getBottomLine();
    this.getReviews();
    this.setProductTypeForReviews(this.productTags);
  },
};
